export const tickerItems = [
  { id: "t1", label: "更新", text: "影视剧组幕后风波全记录", time: "3 分钟前" },
  { id: "t2", label: "上线", text: "综艺剪辑争议脉络梳理", time: "12 分钟前" },
  { id: "t3", label: "深度", text: "音乐版权纠纷时间线", time: "26 分钟前" },
  { id: "t4", label: "完整版", text: "艺人合约变更深度解读", time: "1 小时前" },
  { id: "t5", label: "会员专享", text: "直播行业数据观察合集", time: "2 小时前" },
  { id: "t6", label: "内测", text: "品牌公关回应话术拆解", time: "3 小时前" },
];

export const quickEntries = [
  { id: "e1", icon: "ri-flashlight-line", title: "今日上线", note: "18 条新料" },
  { id: "e2", icon: "ri-file-copy-2-line", title: "完整版专区", note: "会员可看" },
  { id: "e3", icon: "ri-pen-nib-line", title: "深度专栏", note: "每周更新" },
  { id: "e4", icon: "ri-chat-smile-2-line", title: "话题墙", note: "1.2 万讨论" },
  { id: "e5", icon: "ri-vip-crown-2-line", title: "会员专区", note: "内部特权" },
];

export const feedTabs = [
  { id: "all", label: "全部更新" },
  { id: "exclusive", label: "会员专属" },
  { id: "deep", label: "深度长文" },
  { id: "timeline", label: "时间线" },
];

export const feedItems = [
  {
    id: "f1",
    group: "exclusive",
    tag: "会员专属",
    title: "影视剧组幕后风波全记录：从建组到杀青的 47 天",
    excerpt:
      "按时间顺序整理公开可查的节点，补齐普通用户看不到的物料与内部沟通片段，帮助会员快速建立完整脉络。",
    time: "3 分钟前",
    reads: "8.4万",
    comments: 326,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20cinematic%20editorial%20collage%20with%20warm%20amber%20and%20deep%20crimson%20light%20leaks%2C%20folded%20paper%20textures%2C%20scattered%20film%20frames%20and%20soft%20grain%2C%20moody%20documentary%20atmosphere%2C%20no%20text%2C%20no%20faces%2C%20high%20detail%2C%20harmonious%20warm%20palette&width=520&height=360&seq=hl-feed-01&orientation=landscape",
    hot: true,
  },
  {
    id: "f2",
    group: "deep",
    tag: "深度长文",
    title: "综艺剪辑争议脉络梳理：一篇文章看懂三次反转",
    excerpt:
      "把散落在各平台的片段重新拼回完整上下文，标注争议起点、发酵节点与舆情回落区间，附关键截图索引。",
    time: "12 分钟前",
    reads: "6.1万",
    comments: 214,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20editorial%20still%20life%20with%20stacked%20paper%20strips%2C%20amber%20studio%20light%2C%20deep%20red%20accent%20ribbon%2C%20matte%20texture%2C%20soft%20shadows%2C%20magazine%20layout%20feeling%2C%20no%20text%2C%20no%20people%2C%20consistent%20warm%20palette%2C%20high%20detail&width=520&height=360&seq=hl-feed-02&orientation=landscape",
    hot: false,
  },
  {
    id: "f3",
    group: "timeline",
    tag: "时间线",
    title: "音乐版权纠纷时间线：从授权到解约的完整档案",
    excerpt:
      "以日期为轴整理公开声明、合同要点与行业惯例对照，会员可下载结构化的时间线速览卡片。",
    time: "26 分钟前",
    reads: "4.7万",
    comments: 158,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20archive%20desk%20scene%20with%20warm%20amber%20light%2C%20rolled%20paper%20documents%2C%20aged%20folder%20textures%2C%20deep%20crimson%20seal%20accent%2C%20soft%20film%20grain%2C%20editorial%20documentary%20mood%2C%20no%20text%2C%20no%20faces%2C%20consistent%20warm%20palette&width=520&height=360&seq=hl-feed-03&orientation=landscape",
    hot: false,
  },
  {
    id: "f4",
    group: "exclusive",
    tag: "会员专属",
    title: "艺人合约变更深度解读：条款里的七个关键细节",
    excerpt:
      "逐条对照常规合约模板，标出被改动的高频位置，并解释这些改动对后续合作的实际影响。",
    time: "1 小时前",
    reads: "5.3万",
    comments: 197,
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20abstract%20close%20up%20of%20warm%20amber%20paper%20texture%20with%20thin%20crimson%20rule%20lines%2C%20soft%20directional%20light%2C%20matte%20editorial%20magazine%20aesthetic%2C%20gentle%20grain%2C%20no%20text%2C%20no%20people%2C%20warm%20low%20saturation%20palette%2C%20high%20detail&width=520&height=360&seq=hl-feed-04&orientation=landscape",
    hot: false,
  },
  {
    id: "f5",
    group: "deep",
    tag: "行业观察",
    title: "直播行业数据观察合集：季度声量与话题结构变化",
    excerpt:
      "用公开数据看话题结构的迁移路径，解释为什么同一类事件在不同平台的传播速度差异巨大。",
    time: "2 小时前",
    reads: "3.9万",
    comments: 121,
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20studio%20composition%20with%20glass%20panels%2C%20amber%20reflections%2C%20deep%20red%20gradient%20light%2C%20minimal%20editorial%20still%20life%2C%20soft%20shadows%2C%20subtle%20grain%2C%20no%20text%2C%20no%20faces%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=520&height=360&seq=hl-feed-05&orientation=landscape",
    hot: false,
  },
  {
    id: "f6",
    group: "timeline",
    tag: "档案整理",
    title: "品牌公关回应话术拆解：从声明到二次回应的措辞变化",
    excerpt:
      "把历次公开回应并排放在一起，逐句对比措辞调整，理解公众沟通中的取舍与边界。",
    time: "3 小时前",
    reads: "2.8万",
    comments: 96,
    image:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20editorial%20scene%20with%20layered%20envelopes%20and%20ribbon%20details%2C%20amber%20backlight%2C%20crimson%20accent%20cord%2C%20matte%20paper%20texture%2C%20soft%20shadow%20depth%2C%20no%20text%2C%20no%20people%2C%20unified%20warm%20low%20saturation%20palette&width=520&height=360&seq=hl-feed-06&orientation=landscape",
    hot: false,
  },
];

export const topicTags = [
  { id: "g1", label: "剧组幕后", count: "2.4万", size: "lg", tone: "primary" },
  { id: "g2", label: "综艺剪辑", count: "1.9万", size: "md", tone: "secondary" },
  { id: "g3", label: "版权纠纷", count: "1.2万", size: "md", tone: "accent" },
  { id: "g4", label: "合约解读", count: "9860", size: "sm", tone: "secondary" },
  { id: "g5", label: "直播行业", count: "8740", size: "sm", tone: "secondary" },
  { id: "g6", label: "公关回应", count: "7320", size: "sm", tone: "secondary" },
  { id: "g7", label: "时间线档案", count: "6510", size: "md", tone: "accent" },
  { id: "g8", label: "舆情脉络", count: "5980", size: "sm", tone: "secondary" },
  { id: "g9", label: "深度长文", count: "5320", size: "md", tone: "primary" },
  { id: "g10", label: "会员专享", count: "4870", size: "sm", tone: "primary" },
  { id: "g11", label: "幕后物料", count: "4210", size: "sm", tone: "secondary" },
  { id: "g12", label: "行业惯例", count: "3640", size: "sm", tone: "secondary" },
];

export const memberPerks = [
  {
    id: "p1",
    icon: "ri-lock-unlock-line",
    title: "专属解锁",
    desc: "黑料福利会员可直接解锁专属与内部内容，普通用户不可见的部分一次性开放。",
  },
  {
    id: "p2",
    icon: "ri-timer-flash-line",
    title: "提前看料",
    desc: "特权用户比公开渠道提前获取更新，热点发酵前就掌握完整脉络与关键节点。",
  },
  {
    id: "p3",
    icon: "ri-file-list-3-line",
    title: "完整版全文",
    desc: "不受截断限制，长文、时间线与档案整理均可阅读完整版本，附结构化卡片。",
  },
  {
    id: "p4",
    icon: "ri-archive-2-line",
    title: "付费资源全开放",
    desc: "站内付费资源对会员一网打尽，无需重复购买，历史归档同样可查可读。",
  },
];

export const collections = [
  {
    id: "c1",
    title: "幕后档案库",
    subtitle: "从建组到杀青的完整物料索引",
    count: "128 篇",
    tags: ["剧组幕后", "时间线"],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20abstract%20editorial%20cover%20with%20layered%20paper%20fold%20shapes%2C%20amber%20and%20crimson%20gradient%20light%2C%20matte%20texture%2C%20soft%20grain%2C%20magazine%20cover%20aesthetic%2C%20no%20text%2C%20no%20faces%2C%20consistent%20warm%20palette%2C%20high%20detail&width=640&height=440&seq=hl-col-01&orientation=landscape",
  },
  {
    id: "c2",
    title: "争议脉络图鉴",
    subtitle: "热点从起点到回落的结构化复盘",
    count: "76 篇",
    tags: ["舆情脉络", "公关回应"],
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20editorial%20composition%20with%20flowing%20ribbon%20lines%2C%20amber%20backlight%2C%20deep%20red%20accents%2C%20soft%20paper%20texture%2C%20subtle%20film%20grain%2C%20no%20text%2C%20no%20people%2C%20unified%20low%20saturation%20warm%20palette%2C%20high%20detail&width=640&height=440&seq=hl-col-02&orientation=landscape",
  },
  {
    id: "c3",
    title: "合约与版权专栏",
    subtitle: "条款拆解与行业惯例对照",
    count: "54 篇",
    tags: ["合约解读", "版权纠纷"],
    image:
      "https://readdy.ai/api/search-image?query=Warm%20minimal%20editorial%20still%20life%20with%20stacked%20folders%20and%20thin%20crimson%20strings%2C%20amber%20side%20light%2C%20matte%20surface%2C%20soft%20shadows%2C%20gentle%20grain%2C%20no%20text%2C%20no%20faces%2C%20cohesive%20warm%20palette%2C%20high%20detail&width=640&height=440&seq=hl-col-03&orientation=landscape",
  },
  {
    id: "c4",
    title: "行业声量观察",
    subtitle: "季度话题结构与传播速度数据",
    count: "42 篇",
    tags: ["直播行业", "深度长文"],
    image:
      "https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20glass%20and%20paper%20installation%2C%20amber%20reflections%2C%20crimson%20gradient%20glow%2C%20minimal%20editorial%20aesthetic%2C%20soft%20shadow%20depth%2C%20no%20text%2C%20no%20people%2C%20consistent%20warm%20low%20saturation%20palette%2C%20high%20detail&width=640&height=440&seq=hl-col-04&orientation=landscape",
  },
];

export const comments = [
  {
    id: "m1",
    user: "夜航的橘子",
    initial: "橘",
    time: "5 分钟前",
    content: "这条时间线整理得太清楚了，按节点看下来终于把前后关系理顺了，会员提前看真的爽。",
    likes: 428,
    replies: 36,
    topic: "音乐版权纠纷时间线",
    badge: "会员",
  },
  {
    id: "m2",
    user: "存档爱好者",
    initial: "存",
    time: "22 分钟前",
    content: "完整版比公开的多了三段物料索引，之前一直以为是两件事，看完才发现是同一条线。",
    likes: 316,
    replies: 21,
    topic: "影视剧组幕后风波全记录",
    badge: "特权",
  },
  {
    id: "m3",
    user: "只看归纳",
    initial: "归",
    time: "48 分钟前",
    content: "建议新来的先从话题墙逛，按标签点进去比一条条翻效率高太多，脉络图鉴那套尤其适合补课。",
    likes: 254,
    replies: 44,
    topic: "话题墙使用心得",
    badge: "",
  },
  {
    id: "m4",
    user: "小陈同学",
    initial: "陈",
    time: "1 小时前",
    content: "合约那篇的条款对照表太实用了，把改动位置标出来之后，很多看不懂的地方一下就通了。",
    likes: 189,
    replies: 17,
    topic: "艺人合约变更深度解读",
    badge: "会员",
  },
];

export const pricingPlans = [
  {
    id: "pl1",
    name: "体验版",
    price: "0",
    period: "永久免费",
    desc: "先感受专题合集的阅读节奏，适合刚接触黑料福利的用户。",
    features: ["浏览公开更新与话题墙", "查看摘要与部分时间线", "参与评论与话题讨论"],
    highlight: false,
    badge: "",
    cta: "免费浏览",
  },
  {
    id: "pl2",
    name: "会员版",
    price: "29",
    period: "每月",
    desc: "解锁黑料福利专属与内部内容，付费资源一网打尽。",
    features: ["专属与内部内容全解锁", "提前看料、优先更新", "完整版长文与档案", "结构化时间线卡片"],
    highlight: true,
    badge: "最受欢迎",
    cta: "开通会员",
  },
  {
    id: "pl3",
    name: "特权年卡",
    price: "199",
    period: "每年",
    desc: "长期跟进的推荐方案，享受普通用户接触不到的高价值内容。",
    features: ["包含会员版全部权益", "年度深度档案优先开放", "历史归档永久可读", "专属话题内测资格"],
    highlight: false,
    badge: "省 149 元",
    cta: "开通年卡",
  },
];

export const faqs = [
  {
    id: "q1",
    q: "开通黑料福利会员后，具体能解锁哪些内容？",
    a: "会员可解锁站内的专属与内部内容，包括完整版长文、结构化时间线、档案整理专辑，以及付费资源的统一开放权限。普通用户看到的是摘要与部分内容，会员看到的是完整脉络。",
  },
  {
    id: "q2",
    q: "“提前看料”和“完整版”有什么区别？",
    a: "提前看料指的是更新节奏上的优先，热点还在发酵时特权用户就能读到整理好的脉络；完整版指的是篇幅与深度，不受截断限制，包含更多物料索引与对照信息。",
  },
  {
    id: "q3",
    q: "话题墙里的标签是怎么组织的？",
    a: "话题墙按事件类型与内容形态两个维度打标签，例如剧组幕后、综艺剪辑属于题材维度，时间线、深度长文属于形态维度。点击任意标签即可查看该话题下的全部整理内容。",
  },
  {
    id: "q4",
    q: "站内的付费资源需要单独购买吗？",
    a: "不需要。会员期内站内付费资源一网打尽，无需重复购买；年卡用户还可享受历史归档永久可读的权益。",
  },
];